import React, { lazy } from 'react';
import { BrowserRouter, HashRouter, Routes, Route } from 'react-router-dom';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Home = lazy(() => import('../views/home/Home'));
const MyPage = lazy(() => import('../views/my/my'));
const Login = lazy(() => import('../views/login'));
const OrderListPage = lazy(() => import('../views/list'));
const ShopOrderList = lazy(() => import('../views/orderlist'));
const BusinessTurnover = lazy(() => import('../views/businessTurnover'));
const Detail = lazy(() => import('../views/Detail'));
const TestPage = lazy(() => import('../views/testPage'));
export default function Router() {
  // 定义路由配置数组
  const routes = [
    {
      path: "/",
      element: <Login />,
      label: "登录"
    },
    {
      path: "/login",
      element: <Login />,
      label: "登录"
    },
    {
      path: "/orderList",
      element: <OrderListPage />,
      label: "订单页"
    },
    {
      path: "/shopOrderList",
      element: <ShopOrderList />,
      label: "商家订单"
    },
    {
      path: "/businessTurnover",
      element: <BusinessTurnover />,
      label: "营业额"
    },
    {
      path: "/my",
      element: <MyPage />,
      label: "我的"
    },
    {
      path: "/detail/:id",
      element: <Detail />,
      label: "详情页"
    },
    {
      path: "/testPage",
      element: <TestPage />,
      label: "测试页面",
      children: [
        {
          path: ":id",
          element: <Detail />,
          label: "子路由",
        },
      ]
    }
  ];
  return (
    // <BrowserRouter></BrowserRouter>
    <HashRouter>
      <Routes>
        {routes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={route.element}
          >
            {/* 渲染子路由 */}
            {route.children?.map((childRoute, childIndex) => (
              <Route
                key={childIndex}
                path={childRoute.path}
                element={childRoute.element}
              />
            ))}
          </Route>
        ))}
      </Routes>
    </HashRouter>
  );
}